import _ from 'lodash';
import { checkSpelling } from '~core/spellcheck';

const checkSpellingDebounced = _.debounce((target) => {
  checkSpelling(target);
}, 1000);

export default checkSpellingDebounced;
